export default {
    lang: {
        name: 'Language',
        type: String,
        enum: ['en', 'ru'],
        txtDescr: 'Current language',
        default: (v, sett) => 'en',
    }
}



// WEBPACK FOOTER //
// ./main/_sett.js